import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-35">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/90 border-brand-aqua/30 shadow-lg relative overflow-hidden" data-id="element-36">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-aqua/10 rounded-br-full -z-10" data-id="element-37"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-gold/10 rounded-tl-full -z-10" data-id="element-38"></div>

        <h2 className="text-2xl md:text-4xl font-display font-bold mb-8 text-brand-darkGreen leading-tight" data-id="element-39">
          ⚖️ LA DECISIÓN ES TUYA
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text mb-10 max-w-2xl mx-auto" data-id="element-40">
          <p data-id="element-41">
            En este momento existen dos versiones de vos. La primera cierra esta
            página. Y sigue haciendo exactamente lo mismo que hasta ahora.
            Publicando cuando se acuerda. Sin una estrategia clara. Esperando
            recomendaciones.
          </p>

          <p className="font-medium text-brand-aqua" data-id="element-42">
            Y después está la segunda versión. La que entiende que el problema
            no es la falta de conocimientos. La que entiende que no necesita
            otra formación. La que entiende que primero necesita que las
            personas correctas descubran el valor de su trabajo.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-goldDark" data-id="element-43">
            Porque la realidad es simple: Podés ser el mejor terapeuta del
            mundo. Pero si nadie te encuentra... nadie podrá beneficiarse de lo
            que sabés hacer.
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-display font-bold mb-8 text-brand-darkGreen" data-id="element-44">
          ¿CON CUÁL EMPEZÁS?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-10" data-id="element-45">
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-brand-aqua/30 bg-white/85 text-center flex flex-col" data-id="element-46">
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-darkGreen mb-1" data-id="element-47">
              📘 KIT DIGITAL PARA TERAPEUTAS™
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-darkGreen mb-3" data-id="element-48">
              $19.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-49">
              Ideal para terapeutas que quieren construir una presencia
              profesional y empezar a generar más visibilidad.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="https://www.lumenakasha.com/cart/46955331748029:1" variant="gold" data-id="element-50">
              📘 → LO QUIERO $19.990
            </CTAButton>
          </div>

          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-aqua bg-white/95 text-center flex flex-col relative shadow-[0_10px_30px_rgba(13,148,136,0.18)]" data-id="element-51">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-aqua text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" data-id="element-52">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-aqua mb-1 mt-2" data-id="element-53">
              🌟 MEGAPACK DIGITAL PARA TERAPEUTAS™
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-aqua mb-3" data-id="element-54">
              $29.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-55">
              Ideal para terapeutas que quieren dejar de depender del boca a
              boca y construir una práctica profesional sostenible.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="https://www.lumenakasha.com/cart/46955336335549:1" variant="green" data-id="element-56">
              🌟 → LO QUIERO $29.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-57">
          <div className="flex items-center" data-id="element-58">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-59" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-60">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-61" /> Descarga
            inmediata
          </div>
          <div className="flex items-center" data-id="element-62">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-63" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-64">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-65" /> Mercado
            Pago
          </div>
        </div>

        <div className="text-sm text-brand-text bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-aqua/20 space-y-3 text-left md:text-center" data-id="element-66">
          <p data-id="element-67">
            P.D.: No te faltan conocimientos. Te falta visibilidad. Y esa
            decisión puede empezar hoy.
          </p>
        </div>
      </div>
    </Section>;
};